module.exports = __webpack_public_path__ + "media/images/webpage/errors/bg-400-f403c1cf70d495f6809e74cef99b07b0.webp";